<template>
  <div class="grid-x grid-margin-x">
    <div v-if="isMobile" class="cell title-mobile padding-bottom-xs">
      <ProductTitle />
    </div>
    <div :class="cellLeft">
      <Media />
    </div>
    <div :class="cellRight">
      <div v-if="!isMobile" class="title">
        <ProductTitle />
      </div>
      <ShopEligibleItems
        v-if="isMcom ? !(killswitches.featureEnabledG && GWP_PRODUCT_IDS_MCOM.includes(productId)) : isShopEligibleItemsButtonAvailable"
        class="margin-top-m margin-bottom-m"
        data-testid="shop-eligible-items-button"
      />
      <LazyLoadWhenInViewport>
        <SponsoredItemTop
          v-if="showSponsoredItemTop"
          :enable-click-tags-for-s-m-products="killswitches.enableClickTagsForSMProducts"
          :is-simplification-mcom-on="killswitches.priceSimplificationEnabled"
        />
      </LazyLoadWhenInViewport>
    </div>
    <template v-if="isBcom">
      <ProsZoneAVertical v-if="!isMobile" data-testid="pros-section" class="cell large-12 margin-top-xl" />
    </template>
    <div class="cell large-12" data-testid="product-details-section">
      <ProductDetails :class="{ 'margin-top-xl': !isMobile && !showSponsoredItemTop }" />
    </div>
    <template v-if="isMcom">
      <ProsZoneAVertical v-if="!isMobile" data-testid="pros-section" class="cell large-12 small-margin-top-m large-margin-top-xl" />
    </template>
  </div>
</template>

<script setup>
import SponsoredItemTop from '@nuxt-common/site-monetization/app/components/SponsoredItemTop';
import { useBrand } from '~/composables/useBrand';
import Media from '~/components/common/Media/Media';
import ProductTitle from '~/components/productTitle/ProductTitle.common';
import StaticImportProductDetails from '~/modules/productDetails/components/ProductDetails';
import LazyHydratedProductDetails from '~/modules/lazy-hydration/components/ProductDetails';
import ShopEligibleItems from '~/components/ShopEligibleItems.vue';
import ProsZoneAVertical from '~/modules/pros/ProsZoneAVertical';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import LazyLoadWhenInViewport from '~/components/common/LazyLoadWhenInViewport';
import useExperiments from '~/stores/useExperimentsStore';
import useGridLayoutConfig from '~/composables/useGridLayoutConfig';
import { usePageData } from '~/composables/usePageData';
import { GWP_PRODUCT_IDS_MCOM } from '~~/server/constants/productGWPConfig';

const { killswitches } = useKillswitches();

let ProductDetails = StaticImportProductDetails;

// TODO: remove later once lazy hydration testing is over
if (killswitches.isLazyHydrationEnabled) {
  ProductDetails = LazyHydratedProductDetails;
}

const { isMcom, isBcom } = useBrand();
const { showSponsoredItemTop } = useFeatureEligibility();
const { isMobile } = useDeviceType();
const {
  experimentFlags: { isShopEligibleItemsButtonAvailable },
} = useExperiments();
const { cellLeft, cellRight } = useGridLayoutConfig();

const { productId = '' } = usePageData();
</script>

<style lang="scss" brand="mcom" scoped>
@import '~settingSCSS';
@include title;
</style>

<style lang="scss" brand="bcom" scoped>
@import '~settingSCSS';
@include title;
</style>
